"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
require("./Bar.scss");
var BarNavPosition_1 = require("./BarNavPosition");
function BarNav(props) {
    var listClasses = classNames({
        'nav': true,
        'navbar-nav': true,
        'navbar-left': props.position === BarNavPosition_1.BarNavPosition.Left,
        'navbar-right': props.position === BarNavPosition_1.BarNavPosition.Right
    });
    return (React.createElement("ul", { className: listClasses }, props.children));
}
exports.BarNav = BarNav;
//# sourceMappingURL=BarNav.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Bar/BarNav.js
// module id = 572
// module chunks = 1